import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useCampaign, { useCampaignForm } from '@hooks/useCampaign'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const MODAL_KEY = 'EditCampaignPortalDataModal'

type ModalCallbacks = {
  closeModal: () => void,
  updateCampaign: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const EditCampaignPortalDataModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, updateCampaign } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const initCampaign = digObject(modalPayload, 'campaign', {})

  const {
    campaign,
    callbacks: {
      updateCampaign: updateFn,
    },
    incomingPortal: { title },
    updating,
  } = useCampaign(initCampaign)

  const {
    entityState,
    entityState: {
      data,
    },
    handlers,
    saveEnabled,
  } = useCampaignForm(campaign, { validateOn: 'change' })

  const {
    agent_id = '',
    external_api_id = '',
    outgoing_id = '',
    secondary_portal_id = '',
    unique_id = '',
  } = data

  const updateCampaignDataPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Campaign Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Edit Campaign" titleSecondLine="Portal Data" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Incoming Portal" marginTop="large">
            <input disabled name="data.agent_id" value={title || ''} type="text" />
          </Form.Field>

          <Form.Field label="Incoming Agent ID" marginTop="large">
            <input name="data.agent_id" type="text" value={agent_id} {...handlers} />
          </Form.Field>

          <Form.Field label="Incoming Unique ID" marginTop="large">
            <input name="data.unique_id" type="text" value={unique_id} {...handlers} />
          </Form.Field>

          <Form.Field label="Outgoing Unique ID" marginTop="large">
            <input name="data.outgoing_id" type="text" value={outgoing_id} {...handlers} />
          </Form.Field>

          <Form.Field label="External API ID" marginTop="large">
            <input name="data.external_api_id" type="text" value={external_api_id} {...handlers} />
          </Form.Field>

          <Form.Field label="Secondary Portal ID" marginTop="large">
            <input name="data.secondary_portal_id" type="text" value={secondary_portal_id} {...handlers} />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          loadingBubbleColor="white"
          // @ts-expect-error TS2345
          onClick={() => updateCampaign(updateCampaignDataPayload)}
          size="large"
        >
          Save Details
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <EditCampaignPortalDataModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
